module.exports = __webpack_public_path__ + "static/media/survey-of-india-logo11_650_122414035334.440c43a2.jpg";